import React, { Component } from "react";
import {
  Paper,
  Subheader,
  Divider,
  FlatButton,
  MenuItem,
  List,
  ListItem,
  Avatar,
} from "material-ui";
import Formsy from "formsy-react";
import { FormsyText, FormsySelect } from "formsy-material-ui/lib";
import Loading from "../../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FormsyDate from "../../forms/formComponents/FormsyDate";
import formatDate from "../../../../utils/formatDate";
import getDateTime from "../../../../utils/getDateTime";
import toTeamworkDate from "../../../../utils/toTeamworkDate";
import SelectableList from "../../SelectableList";

import BigCalendar from "react-big-calendar";
import "../../../styles/Scheduler/styles.less";
import moment from "moment";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class TeamworkCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      loadingMessage: "",
      projects: [],
      responsibleParties: [],
      tasks: [],
      highPriorityTasks: [],
      capturedTasks: [],
      filtered: false,
      calendarEvents: [],
      employeeColors: {
        "-1": "#CFD8DC",
        133594: "#7E57C2",
        117419: "#66BB6A",
        117421: "#5C6BC0",
        117420: "#EC407A",
        117395: "#D4E157",
        117689: "#FFCA28",
        117554: "#FF7043",
        126997: "#26A69A",
        158315: "#AB47BC",
        120897: "#FFA726",
        137922: "#ef5350",
      },
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
        paperStyle: {
          height: window.screen.height - 240,
          marginTop: "2em",
          marginBottom: "2em",
          marginLeft: "2em",
          paddingTop: "1em",
          paddingBottom: "1em",
        },
        innerPaperStyle: {
          height: window.screen.height - 350,
          maxHeight: window.screen.height - 350,
          overflow: "auto",
        },
        priorityPaperStyle: {
          height: "15em",
          maxHeight: "15em",
          marginTop: "2em",
          marginLeft: "2em",
          paddingTop: "1em",
          paddingBottom: "1em",
        },
        priorityInnerStyle: {
          overflow: "auto",
          height: "10em",
          maxHeight: "10em",
        },
      },
    };

    this.loadJobs = this.loadJobs.bind(this);
    this.loadTasks = this.loadTasks.bind(this);
    this.loadFormSelections = this.loadFormSelections.bind(this);
    this.submitTaskForm = this.submitTaskForm.bind(this);
    this.filterCalendar = this.filterCalendar.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.renderSelection = this.renderSelection.bind(this);
    this.renderEmployee = this.renderEmployee.bind(this);
    this.renderEvent = this.renderEvent.bind(this);
    this.renderDateCellWrapper = this.renderDateCellWrapper.bind(this);
  }

  loadTasks() {
    return new Promise((resolve, reject) => {
      let url = `/api/teamwork/getStaticTasks`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
          else reject();
        })
        .then((json) => {
          this.setState({
            loadingMessage: this.state.loadingMessage + "\n Tasks Loaded",
          });
          let highPriority = json.filter((task) => {
            return task.priority === "high";
          });
          resolve({ tasks: json, highPriorityTasks: highPriority });
        });
    });
  }

  loadJobs() {
    return new Promise((resolve, reject) => {
      let url = `/api/teamwork/getCapturedTasks`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
          else reject();
        })
        .then((json) => {
          this.setState({
            loadingMessage: this.state.loadingMessage + "\n Jobs Loaded",
          });
          resolve(json);
        });
    });
  }

  loadFormSelections() {
    return new Promise((resolve, reject) => {
      let url = `/api/teamwork/projectFormSelections`;
      let options = {
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
          else reject();
        })
        .then((json) => {
          this.setState({
            loadingMessage: this.state.loadingMessage + "\n Employees Loaded",
          });
          let responsibleParties = [{ name: "Anyone", id: "-1" }].concat(
            json.responsibleParties,
          );
          resolve(responsibleParties);
        });
    });
  }

  componentWillMount() {
    let p = [];
    p.push(this.loadTasks());
    p.push(this.loadJobs());
    p.push(this.loadFormSelections());

    Promise.all(p).then((values) => {
      this.setState({
        tasks: values[0].tasks,
        highPriorityTasks: values[0].highPriorityTasks,
        capturedTasks: values[1],
        responsibleParties: values[2],
        isLoading: false,
      });
    });
  }

  submitTaskForm(data) {
    let url = "/api/teamwork/capture";
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify({ data }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.loadJobs();
      });
    this.props.closeDialog();
  }

  filterCalendar(data) {
    let calendarEvents = this.state.tasks.filter((task) => {
      let assigned = false;
      task.assignedTo.map((employee) => {
        if (employee.id == data.responsibleParty) assigned = true;
      });
      return assigned;
    });
    this.setState({ filtered: true, calendarEvents: calendarEvents });
  }

  clearFilter() {
    this.setState({ filtered: false, calendarEvents: [] });
  }

  openTaskDialog() {
    let { centerStyle } = this.state.styles;
    let title = "";
    let actions = [];

    // let responsiblePartySelections = this.state.responsibleParties.map(project => {
    // 	return <MenuItem primaryText={project.name} value={project.id} />
    // });

    let content = [
      <Formsy.Form key="taskCapture" onValidSubmit={this.submitTaskForm}>
        <div style={{ width: "75%", marginLeft: "auto", marginBottom: "auto" }}>
          <h2>New Job</h2>
          <FormsyText
            required
            name="name"
            floatingLabelText="Name"
            hintText="Job Name"
          />
          <br />
          <FormsyText
            multiLine
            name="description"
            floatingLabelText="Description"
          />
          {/*<br/>
					<FormsySelect 
						fullWidth
						name='responsibleParty'
						floatingLabelText='Assign to Employee'
						style={{width: '50%'}}
					>
						{responsiblePartySelections}
					</FormsySelect>*/}
          <br />
          <FormsyDate
            name="startDate"
            firstDayOfWeek={0}
            formatDate={(date) => formatDate(date)}
            floatingLabelText="Start Date"
          />
          <FormsyDate
            name="endDate"
            firstDayOfWeek={0}
            formatDate={(date) => formatDate(date)}
            floatingLabelText="End Date"
          />
          {/*<FormsyText
						name='hours'
						floatingLabelText='Estimated Hours'
					/>
					<br/>*/}
          <FlatButton
            key="cancel"
            label="Cancel"
            onClick={this.props.closeDialog.bind(this)}
          />
          <FlatButton key="save" label="Save" type="submit" />
        </div>
      </Formsy.Form>,
    ];
    this.props.openDialog(title, content, actions);
  }

  renderSelection(item, i) {
    return <ListItem key={i} primaryText={item.name} value={item.id} />;
  }

  renderEmployee(employee, i) {
    let colors = this.state.employeeColors;
    return (
      <ListItem
        key={i}
        primaryText={employee.name}
        value={employee.id}
        leftAvatar={
          <Avatar color="#EEEEEE" backgroundColor={colors[employee.id]} />
        }
      />
    );
  }

  renderEvent(event) {
    let assigned =
      event.event.assignedTo.length > 0 ? event.event.assignedTo[0].id : "-1";
    return (
      <div
        style={{
          backgroundColor: this.state.employeeColors[assigned],
          paddingLeft: "0.33em",
          paddingRight: "0.33em",
        }}
      >
        {event.event.name}
      </div>
    );
  }

  renderDateCellWrapper(dates) {
    let date = dates.value;
    let hours = 0;
    let color = "#FAFAFA";
    let tasks = this.state.calendarEvents.filter((task) => {
      return toTeamworkDate(new Date(task.c_startDate)) == toTeamworkDate(date);
    });

    tasks.map((task) => {
      let time = parseInt(task.numEstMins) / 60;
      hours += time;
    });

    if (hours > 6) color = "#e57373";
    else if (hours > 4) color = "#FFB74D";
    else if (hours > 2) color = "#FFEE58";
    else if (hours > 0) color = "##AED581";

    if (this.state.filtered) {
      return (
        <div style={{ width: "100%" }}>
          <div
            style={{
              backgroundColor: color,
              merginLeft: "0.05em",
              position: "absolute",
              bottom: 0,
            }}
          >
            {hours.toFixed(2)}
          </div>
        </div>
      );
    } else {
      return <div style={{ width: "100%" }}></div>;
    }
  }

  render() {
    let {
      paperStyle,
      centerStyle,
      innerPaperStyle,
      priorityPaperStyle,
      priorityInnerStyle,
    } = this.state.styles;
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
            <p>{this.state.loadingMessage}</p>
          </center>
        </div>
      );
    } else {
      return (
        <div>
          <Paper
            className="container col-sm-4"
            zDepth={2}
            style={priorityPaperStyle}
          >
            <Subheader>Filter Calendar</Subheader>
            <Divider />
            <Formsy.Form
              key="filterCalendar"
              onValidSubmit={this.filterCalendar}
            >
              <div>
                <FormsySelect
                  fullWidth
                  name="responsibleParty"
                  floatingLabelText="Employee"
                >
                  {this.state.responsibleParties.map((party, i) => {
                    return (
                      <MenuItem
                        key={i}
                        primaryText={party.name}
                        value={party.id}
                      />
                    );
                  })}
                </FormsySelect>
                <br />
                <center>
                  <FlatButton key="filter" label="Filter" type="submit" />
                  <br />
                  <FlatButton
                    key="clearFilter"
                    label="Clear Filter"
                    onClick={this.clearFilter}
                  />
                </center>
              </div>
            </Formsy.Form>
          </Paper>
          <Paper
            className="container col-sm-7"
            zDepth={2}
            style={priorityPaperStyle}
          >
            <Subheader>High Priority</Subheader>
            <Divider />
            <div style={priorityInnerStyle}>
              <SelectableList defaultValue={-1}>
                {this.state.highPriorityTasks.map(this.renderSelection)}
              </SelectableList>
            </div>
          </Paper>
          <Paper className="container col-sm-7" zDepth={2} style={paperStyle}>
            <BigCalendar
              views={["month"]}
              events={
                this.state.filtered
                  ? this.state.calendarEvents
                  : this.state.tasks
              }
              startAccessor="c_startDate"
              endAccessor="c_dueDate"
              titleAccessor="name"
              popup
              components={{
                event: this.renderEvent,
                dateCellWrapper: this.renderDateCellWrapper,
                // dayWrapperComponent: this.renderDateCellWrapper
              }}
            />
          </Paper>
          <Paper className="container col-sm-2" zDepth={2} style={paperStyle}>
            <Subheader>Jobs</Subheader>
            <Divider />
            <div style={innerPaperStyle}>
              <SelectableList defaultValue={-1}>
                {this.state.capturedTasks.map(this.renderSelection)}
              </SelectableList>
            </div>
            <Divider />
            <FlatButton
              label="New Task"
              onClick={this.openTaskDialog.bind(this)}
            />
          </Paper>
          <Paper className="container col-sm-2" zDepth={2} style={paperStyle}>
            <Subheader>Employees</Subheader>
            <Divider />
            <div style={innerPaperStyle}>
              <SelectableList defaultValue={-1}>
                {this.state.responsibleParties.map(this.renderEmployee)}
              </SelectableList>
            </div>
            <Divider />
          </Paper>
        </div>
      );
    }
  }
}

export default TeamworkCalendar;



// WEBPACK FOOTER //
// ./app/components/teamwork/scheduler/TeamworkCalendar.js